<template>
  <div class="card card-chat">
    <p v-if="data.subheading" style="text-align: center" v-html="data.subheading"></p>
    <div class="card-body" style="max-height: 500px;overflow-y: scroll">
      <ol class="chat">
        <li v-for="(comment, index) in comments" class="comment">
          <div class="msg-container" :ref="'commentContainer' + index">
            <p>{{ getUserDisplayName(comment.byUserId) }} &middot; {{ comment.createdAt | formatDateTime }}</p>
            <p v-html="comment.message"></p>
            <p>
              <a href="#" v-if="canEdit(comment)" @click.prevent="editComment(comment, index)">Edit</a>
              &middot;
              <a href="#" v-if="canEdit(comment)" @click.prevent="deleteComment(comment)">Delete</a>
            </p>
          </div>
          <div class="edit-comment-container" :ref="'editCommentContainer' + index" style="display:none">
            <ckeditor
              :id="'_' + comment.id"
              :ref="'_' + comment.id"
              :v-validate="'required'"
              :name="'editComment_' + index"
              data-vv-as="edit comment"
              data-vv-scope="editComment"
              :editor="editor"
              v-model="comment.message"
              v-validate="'required'"
              :config="ckEditorConfig">
            </ckeditor>
            <small class="text-danger" v-show="errors.has('editComment_' + index, 'editComment')" style="display:block;">
              {{ getError('editComment_' + index, 'editComment') }}
            </small>
            <div class="edit-buttons save-button-container">
              <button @click="validateAndSubmit(comment)" :disabled="errors.has('editComment_' + index, 'editComment')" class="btn btn-primary btn-fill">Save</button>
              <button @click="hideEditEditor(comment, index)" class="btn btn-primary btn-fill">Cancel</button>
            </div>
          </div>
        </li>
      </ol>
      <div class="col-md-12">
        <div class="send-message">
          <textarea class="leave-a-comment" ref="leaveAComment" @click="showAddCommentEditor">Add a comment</textarea>
          <div class="editor-container" ref="addCommentContainer">
            <ckeditor
              id="addComment"
              name="addComment"
              ref="addComment"
              data-vv-as="add comment"
              data-vv-scope="addComment"
              :editor="editor"
              v-model="edit.message"
              :v-validate="'required'"
              :config="ckEditorConfig">
            </ckeditor>
            <small class="text-danger" v-show="errors.has('addComment', 'addComment')" style="display:block;">
              {{ getError('addComment', 'addComment') }}
            </small>
            <div class="save-button-container">
              <button @click="validateAndSubmit(null)" :disabled="errors.has('addComment', 'addComment')" class="btn btn-primary btn-fill">Save</button>
              <button @click="hideAddCommentEditor" class="btn btn-primary btn-fill">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import {notifyError} from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'
  import CKEditor from '@ckeditor/ckeditor5-vue'
  import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
  import ckEditorConfig from 'src/utilities/ckeditor'
  import {sync} from 'vuex-pathify'
  import {NO_CONTENT} from 'http-status-codes'

  export default {
    props: ['data'],
    components: {
      ckeditor: CKEditor.component
    },
    computed: {
      edit: sync('comments@edit'),
      ...mapGetters({
        comments: 'comments/results',
        userId: 'security/userId'
      })
    },
    data() {
      return {
        editor: ClassicEditor,
        ckEditorConfig,
        undo: null,
        messageBeforeEdit: null,
        modelValidations: {
          message: {
            required: true,
          }
        },
        constants: Constants
      }
    },
    methods: {
      showAddCommentEditor () {
        this.hideEditEditors()
        this.$validator.reset()
        this.$refs.leaveAComment.style.display = 'none'
        this.$refs.addCommentContainer.style.display = 'block'
      },
      hideAddCommentEditor () {
        this.$refs.leaveAComment.style.display = 'block'
        this.$refs.addCommentContainer.style.display = 'none'
        this.errors.clear('addComment')
        this.$store.commit('comments/resetMessage')
      },
      hideEditEditors() {
        for (let prop in this.$refs) {
          if (Array.isArray(this.$refs[prop])) {
            const ref = this.$refs[prop][0]
            if (ref && ref.style) {
              if (ref.className === 'msg-container') {
                ref.style.display = 'block'
              } else if (ref.className === 'edit-comment-container') {
                ref.style.display = 'none'
              }
            }
          }
        }
      },
      hideEditEditor(comment, index) {
        comment.message = this.undo
        this.$refs['commentContainer' + index][0].style.display = 'block'
        this.$refs['editCommentContainer' + index][0].style.display = 'none'
        this.$store.commit('comments/resetMessage')
      },
      editComment(comment, index) {
        this.undo = comment.message
        this.hideAddCommentEditor()
        this.hideEditEditors()
        this.$refs['commentContainer' + index][0].style.display = 'none'
        this.$refs['editCommentContainer' + index][0].style.display = 'block'
      },
      async deleteComment(comment) {
        const response = await this.$store.dispatch('delete', {
          endpoint: 'comments',
          id: comment.id
        })

        if (NO_CONTENT === response.status) {
          this.$store.commit('comments/decrementCommentCount', this.edit.parentEntityIdHash)
          this.$store.commit('comments/deleteComment', comment.id)
        }
      },
      getUserDisplayName(userId) {
        return this.$store.getters['users/displayName'](userId)
      },
      getError(fieldName, scope) {
        return this.errors.first(fieldName, scope)
      },
      canEdit(comment) {
        return comment.byUserId === this.userId
      },
      async validateAndSubmit(comment) {
        let response
        let scope = 'addComment'
        if (comment) {
          scope = 'editComment'
        }
        if (await this.$validator.validateAll(scope)) {
          if (comment) {
            comment.byUserId = this.userId
            const putPayload = {
              id: comment.id,
              endpoint: 'comments',
              data: comment
            }
            response = await this.$store.dispatch('put', putPayload)
          } else {
            const postPayload = this.$store.getters['comments/postPayload']
            postPayload.data.byUserId = this.userId
            response = await this.$store.dispatch('post', postPayload)
          }

          if (response.result === Constants.RETURN_CODES.SUCCESS) {
            if (scope === 'addComment') {
              this.$store.commit('comments/appendComment', response.data)
              this.$store.commit('comments/incrementCommentCount', this.edit.parentEntityIdHash)
              this.$store.commit('comments/resetMessage')
            } else {
              this.$store.commit('comments/updateComment', response.data)
              this.$store.commit('comments/resetMessage')
            }

            this.hideEditEditors()
            this.hideAddCommentEditor()
          } else {
            notifyError(this, 'Failed to load Comments', response.data.errors)
          }
        }
      }
    },
    async beforeMount() {
      await this.$store.dispatch('comments/fetchByParentEntityId', this.data.parentId)
    }
  }
</script>
<style scoped>
  .msg-container {
    margin-left: 10px;
  }
  li.comment {
    padding: 10px 0;
  }
  .save-button-container {
    text-align: left;
  }
  .send-message {
    padding: 0 30px;
  }
  .send-message .editor-container {
    display: none;
  }
  .leave-a-comment {
    width: 100%;
    padding: 5px;
    border-radius: 5px;
    border-color: #6e8e8f;
    color: #6e8e8f;
  }
  .card {
    box-shadow: none;
  }
  .edit-comment-container {
    padding-left: 10px;
  }
</style>
